import { useCurrentUserStore } from '@/stores/current-user'

export interface CurrentUser {
  id: string
  email: string
  first_name: string
  last_name: string
  picture: string
}

export class CurrentUserService {
  /**
   * Sets the current user in the store.
   */
  static setCurrentUser(user: CurrentUser | null): void {
    const store = useCurrentUserStore()
    if (user) store.setUser(user)
    else store.clearUser()
  }

  /**
   * Returns the current user from the store.
   */
  static getCurrentUser(): CurrentUser | null {
    return useCurrentUserStore().user
  }

  /**
   * Clears the stored current user from session storage.
   */
  static clearCurrentUser(): void {
    const store = useCurrentUserStore()
    store.clearUser()
  }
}
